import { Button } from "@/components/ui/button";

const CTABanner = ({ onShopClick }) => {
  return (
    <section 
      className="py-16 md:py-20"
      data-testid="cta-banner"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="gradient-cta rounded-3xl p-8 md:p-12 lg:p-16 relative overflow-hidden">
          {/* Background Effects */}
          <div className="absolute inset-0 opacity-30">
            <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_20%_50%,rgba(255,255,255,0.1)_0%,transparent_50%)]" />
            <div className="absolute bottom-0 right-0 w-full h-full bg-[radial-gradient(circle_at_80%_80%,rgba(255,255,255,0.1)_0%,transparent_50%)]" />
          </div>
          
          <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-8">
            {/* Content */}
            <div className="text-center lg:text-left max-w-xl">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-white mb-4">
                Your mind is your edge.
                <br />
                <span className="text-white/80">Start using it.</span>
              </h2>
              <p className="text-white/70">
                Join thousands of high-performers who trust Nukleus for sustained focus and mental clarity. 
                Risk-free with our 30-day guarantee.
              </p>
            </div>

            {/* CTA */}
            <div className="flex flex-col items-center lg:items-end gap-3">
              <Button
                onClick={onShopClick}
                className="bg-white text-nukleus-bg hover:bg-white/90 rounded-full px-8 py-6 text-base font-semibold shadow-lg hover:shadow-xl transition-all"
                data-testid="cta-banner-btn"
              >
                Get Nukleus — $44.99
              </Button>
              <span className="text-white/50 text-sm">
                Free US shipping on all orders
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
